import { CloseSquare } from "iconsax-react";
import Spinner from "../../spinners/Spinner";

export const ConfirmationModal = ({ msg, cta, onClose, ctaLoading }) => {
  return (
    <div className="fixed min-w-[400px] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-40 bg-white overflow-y-scroll scrollbar-hide rounded-md block">
      <div className="sticky left-0 right-0 top-0">
        <div className="bg-[#f1f1f1] px-5 py-4 flex justify-between">
          <div className="text-[15px] font-medium select-none max-w-[300px]">
            <h2>{msg}</h2>
          </div>
          <button onClick={onClose}>
            <CloseSquare variant="Bold" />
          </button>
        </div>
      </div>
      <div className="flex justify-between items-end flex-wrap py-5 px-5">
        <button
          className="text-xs w-[70px] h-[40px] flex items-center justify-center bg-[tomato] text-white rounded-md py-2 px-2 hover:opacity-80 duration-200"
          onClick={cta}
        >
          {ctaLoading ? <Spinner color={'white'} /> : 'Yes'}
        </button>
        <button
          className="text-xs w-[70px] h-[40px] flex items-center justify-center bg-primary-light rounded-md py-2 px-2 hover:opacity-80 duration-200"
          onClick={onClose}
        >
          No
        </button>
      </div>
    </div>
  );
};
